import { SystemStorageType } from '../../../App/model/system-storage-types';
import { DataStorage, IDataProvider } from '../../../App/services/mx-data-storage';

/**
 * @ngdoc service
 * @kind function
 * @name mx.shell.TrackedProcessProvider
 * @module mx.shell
 *
 * @description
 * Provides operations to work with data storage to persist tracked processes
 */
export class MxTrackedProcessProvider {
	static $inject = ['mx.shell.DataStorage'];
	private readonly _storage: IDataProvider;
	private _trackedProcessIds: Array<string>;

	constructor(private readonly dataStorage: DataStorage) {
		this._storage = this.dataStorage.getStorage(SystemStorageType.LocalStorage);
		this._trackedProcessIds = (this._storage.getAsObject('mx.shell.backgroundProcessesService.trackedProcessIds') as Array<string>) || [];
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.TrackedProcessesProvider#add
	 *
	 * @description
	 * Adds new tracked process
	 *
	 * @param trackedProcessId
	 */
	public add(trackedProcessId: string): void {
		const id = trackedProcessId.toLocaleLowerCase();
		if (this._trackedProcessIds.indexOf(id) < 0) {
			this._trackedProcessIds.push(id);
			this._storage.setAsObject('mx.shell.backgroundProcessesService.trackedProcessIds', this._trackedProcessIds);
		}
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.TrackedProcessesProvider#sync
	 *
	 * @description
	 * Synchronizes running processes with a tracked processes
	 *
	 * @param trackedProcessIds
	 */
	public sync(trackedProcessIds: Array<string>): void {
		const ids = trackedProcessIds.map((id) => id.toLocaleLowerCase());
		this._trackedProcessIds = ids.filter((id) => this._trackedProcessIds.includes(id));
		this._storage.setAsObject('mx.shell.backgroundProcessesService.trackedProcessIds', this._trackedProcessIds);
	}

	/**
	 * @ngdoc property
	 * @name mx.shell.TrackedProcessesProvider#count
	 *
	 * @description
	 * Counts tracked processes
	 */
	public get count(): number {
		return this._trackedProcessIds.length;
	}
}
